<template>
  <div class="addInjectable">
    <el-dialog v-loading="loading" :visible.sync="dialogForm" center class="dialogItem" :close-on-click-modal="false">
      <h3>新增登记表-外科</h3>
      <el-form label-width="110px" :inline="true" :model="formData" ref="formData" :rules="rules">
        <el-divider>客户基本信息</el-divider>
        <h5>客户基本信息</h5>
        <div class="card">
          <el-form-item label="手机号">
            <el-input v-model="formData.clientMobile" placeholder="请输入手机号" @input="testSX" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="卡号">
            <el-input v-model="formData.clientCard" placeholder="请输入卡号" @input="testSX" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="姓名" class="service">
            <el-input v-model="formData.clientName" placeholder="请输入姓名" @input="testSX"></el-input>
          </el-form-item>
          <el-button class="info" type="primary" @click="getInfo" size="mini">获取信息</el-button>
          <el-form-item label="客服" prop="serviceName">
            <el-input v-model="formData.serviceName" placeholder="请输入客服姓名" @input="testSX"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="clientSex">
            <el-select v-model="formData.clientSex" @input="testSX">
              <el-option v-for="(item,index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input v-model="formData.clientAge" placeholder="请输入年龄" @input="testSX"></el-input>
          </el-form-item>
        </div>
        <h5>手术登记表</h5>
        <div class="card">
          <el-form-item label="日期" prop="time">
            <el-date-picker @input="testSX" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="formData.time" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="类别" prop="category">
            <el-select @input="testSX" v-model="formData.category" placeholder="请选择类别">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <div class="card" v-for="(item, index) in formData.operationRegister" :key="index">
            <div>
              <el-form-item label="主刀医生" :prop="'operationRegister.' + index + '.operatorDoctor'" :rules="rules.operatorDoctor">
                <el-select ref='doctor13' @keydown.enter.native="enterDoctor($event,index,13)" default-first-option @change="regisChange($event,index)" @input="testSX" v-model="item.operatorDoctor" @blur="docotrBlur" @focus="docotrFocus(13)" filterable clearable placeholder="请输入主刀医生姓名" :filter-method="(value) => docotrMatch(value, 13)">
                  <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="麻醉医生" :prop="'operationRegister.' + index + '.anesthetistName'" :rules="rules.anesthetistName">
                <el-select ref='doctor11' @keydown.enter.native="enterDoctor($event,index,11)" default-first-option @change="anestChange($event,index)" @blur="docotrBlur" @input="testSX" v-model="item.anesthetistName" @focus="docotrFocus(11)" filterable clearable placeholder="请输入麻醉医生姓名" :filter-method="(value) => docotrMatch(value, 11)">
                  <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item label="规范手术名称" :prop="'operationRegister.' + index + '.operationName'" :rules="rules.operationName">
              <el-select default-first-option @keydown.enter.native="enterDoctor($event,index,23)" @input="testSX" @change="operationChange($event,index)" v-model="item.operationName" @visible-change='operaChange' filterable remote clearable @focus="operaFocus($event,index)" placeholder="请选择规范手术名称(多选)" multiple :filter-method="operationNameMatch">
                <el-option v-for="item in operaOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="诊断" :prop="'operationRegister.' + index + '.diagnosis'" :rules="rules.diagnosis">
              <el-select allow-create @change="diaChange" @keydown.enter.native="enterDoctor($event,index,24,item.diagnosis)" default-first-option @input="testSX" v-model="item.diagnosis" @visible-change='diagnosischange' @focus="diagnosisFocus($event,index)" filterable remote clearable placeholder="请输入诊断名称(多选)" multiple :filter-method="diagnosMatch">
                <el-option v-for="item in diagnosisOptions" :key="item.id" :label="item.menuName" :value="item.menuName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="麻醉方式" :prop="'operationRegister.' + index + '.anesthesiaMode'" :rules="rules.anesthesiaMode">
              <el-select @input="testSX" @change="modeChange($event,index)" v-model="item.anesthesiaMode" placeholder="请选择麻醉方式" @focus="anesFocus" clearable>
                <el-option v-for="item in anesOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="副刀医生" :prop="'operationRegister.' + index + '.assistantDoctor'" :rules="rules.assistantDoctor">
              <el-select @keydown.enter.native="enterDoctor($event,index,14)" default-first-option @input="testSX" @change="assistChange($event,index)" v-model="item.assistantDoctor" @focus="docotrFocus(14)" filterable remote clearable placeholder="请输入副刀医生姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 14)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实际手术医生" :prop="'operationRegister.' + index + '.practicalOperationDoctor'" :rules="rules.practicalOperationDoctor">
              <el-select @keydown.enter.native="enterDoctor($event,index,16)" default-first-option @input="testSX" @change="practicalChange($event,index)" v-model="item.practicalOperationDoctor" @focus="docotrFocus(13)" filterable remote clearable placeholder="请输入实际手术医生(多选)" :filter-method="(value) => docotrMatch(value, 13)" multiple>
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="洗手护士" :prop="'operationRegister.' + index + '.washNurse'">
              <el-select @keydown.enter.native="enterDoctor($event,index,17)" default-first-option @input="testSX" v-model="item.washNurse" @blur="docotrBlur" @focus="docotrFocus(12)" filterable remote clearable placeholder="请输入洗手护士姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 12)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="巡回护士" :prop="'operationRegister.' + index + '.tourNurse'" :rules="rules.tourNurse">
              <el-select @keydown.enter.native="enterDoctor($event,index,18)" default-first-option @input="testSX" @blur="docotrBlur" @change="nurseChange($event,index)" v-model="item.tourNurse" @focus="docotrFocus(12)" filterable remote clearable placeholder="请输入巡回护士姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 12)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input @input="testSX" v-model="item.remarks" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item class="button">
              <el-button size="mini" type="danger" @click.prevent="removeForm(item,index)" v-show="index > 0">
                <i class="el-icon-delete"></i>
              </el-button>
            </el-form-item>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="addForm" type="primary" size="mini">新增手术登记表</el-button>
          </el-form-item>
        </div>

        <el-divider>耗材登记表</el-divider>
        <h5>院区信息</h5>
        <div class="card">
          <el-form-item label="院区" prop="areaName">
            <el-select @input="testSX" v-model="formData.areaName" placeholder="请选择院区">
              <el-option v-for="item in areaOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科室">
            <el-input disabled v-model="formData.dsepartmentName"></el-input>
          </el-form-item>
        </div>
        <h5>手术信息</h5>
        <div>
          <div class="card" v-for="(item, index) in formData.operationMaterials " :key="index">
            <el-form-item label="手术名称" :prop="'operationMaterials.' + index + '.operationName'" :rules="rules.surgeryName">
              <el-select @keydown.enter.native="enterDoctor($event,index,28)" default-first-option @input="testSX" @visible-change='operaChange' v-model="item.operationName" filterable remote clearable @focus="operaFocus($event,index)" placeholder="请输入手术名称(多选)" multiple :filter-method="operationNameMatch">
                <el-option v-for="item in operaOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <!-- 新加的字段 -->
            <el-form-item label="实际手术名称" :prop="'operationMaterials.' + index + '.practicalOperationName'" :rules="rules.practicalOperationName">
              <span class="no">
                <el-select :popper-append-to-body="false" default-first-option @input="testSX" v-model="item.practicalOperationName" allow-create filterable clearable placeholder="请输入实际手术名称" multiple></el-select>
              </span>
            </el-form-item>
            <el-form-item label="医生姓名" :prop="'operationMaterials.' + index + '.doctorName'" :rules="rules.doctorName">
              <el-select @keydown.enter.native="enterDoctor($event,index,19)" default-first-option @input="testSX" @blur="docotrBlur" v-model="item.doctorName" @focus="docotrFocus(13)" filterable remote clearable placeholder="请输入医生姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 13)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="护士姓名" :prop="'operationMaterials.' + index + '.nurseName'" :rules="rules.nurseName">
              <el-select @keydown.enter.native="enterDoctor($event,index,20)" default-first-option @input="testSX" @blur="docotrBlur" v-model="item.nurseName" @focus="docotrFocus(12)" filterable remote clearable placeholder="请输入护士姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 12)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="医助姓名" :prop="'operationMaterials.' + index + '.assistantName'" :rules="rules.assistantName">
              <el-select @keydown.enter.native="enterDoctor($event,index,21)" default-first-option @input="testSX" @blur="docotrBlur" v-model="item.assistantName" @focus="docotrFocus(14)" filterable remote clearable placeholder="请输入医助姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 14)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="麻醉医生" :prop="'operationMaterials.' + index + '.anesthetistName'" :rules="rules.anesthetistName">
              <el-select @keydown.enter.native="enterDoctor($event,index,22)" default-first-option @input="testSX" v-model="item.anesthetistName" @blur="docotrBlur" @focus="docotrFocus(11)" filterable remote clearable placeholder="请输入麻醉医生姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 11)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场地" :prop="'operationMaterials.' + index + '.place'" :rules="rules.place">
              <el-select ref='place' @keydown.enter.native="enterDoctor($event,index,26)" default-first-option @input="testSX" v-model="item.place" @focus="placeFocus" clearable placeholder="请选择场地" filterable remote :filter-method="placeMatch">
                <el-option v-for="item in placeOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入室时间" :prop="'operationMaterials.' + index + '.entranceTime'" :rules="rules.entranceTime">
              <el-time-picker @input="testSX" value-format="HH:mm" format="HH:mm" v-model="item.entranceTime" placeholder="请选择入室时间"></el-time-picker>
            </el-form-item>
            <el-form-item label="手术时间" :prop="'operationMaterials.' + index + '.operationTimeEnd'">
              <el-time-picker @input="testSX" format="HH:mm" value-format="HH:mm" v-model="item.operationTimeStart" placeholder="请选择手术开始时间"></el-time-picker><span>至</span>
              <el-time-picker @change="timeChange($event,index)" @input="testSX" format="HH:mm" value-format="HH:mm" v-model="item.operationTimeEnd" placeholder="请选择手术结束时间"></el-time-picker>
              <!-- <el-time-picker @input="testSX" value-format="HH:mm" format="HH:mm" v-model="item.operationTimeStart" placeholder="请选择手术开始时间"></el-time-picker>
              <el-time-picker @input="testSX" value-format="HH:mm" format="HH:mm" v-model="item.operationTimeEnd" placeholder="请选择手术结束时间"></el-time-picker> -->
              <!-- <el-time-picker @input="testSX" value-format="HH:mm" format="HH:mm" is-range v-model="item.bbStart" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-time-picker> -->
            </el-form-item>
            <el-form-item label="麻醉方式" :prop="'operationMaterials.' + index + '.anesthesiaMode'" :rules="rules.anesthesiaMode">
              <el-select @input="testSX" v-model="item.anesthesiaMode" placeholder="请选择麻醉方式" @focus="anesFocus" clearable>
                <el-option v-for="item in anesOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="麻醉时间" :prop="'operationMaterials.' + index + '.anesthesiaTimeEnd'">
              <!-- <el-time-picker @input="testSX" is-range value-format="HH:mm" format="HH:mm" v-model="item.aaStart" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-time-picker> -->
              <el-time-picker @input="testSX" value-format="HH:mm" format="HH:mm" v-model="item.anesthesiaTimeStart" placeholder="请选择麻醉开始时间"></el-time-picker><span>至</span>
              <el-time-picker @input="testSX" @change="valueChange($event,index)" value-format="HH:mm" format="HH:mm" v-model="item.anesthesiaTimeEnd" placeholder="请选择麻醉结束时间"></el-time-picker>
            </el-form-item>
            <div class="flex" v-for="(domain, idx) in item.productList " :key="idx">
              <el-form-item label="产品名称" :prop="'operationMaterials.'+index+'.productList.'+idx+'.productName'" :rules="rules.productName">
                <el-select ref="productName" @keydown.enter.native="enterDoctor($event,index,30,idx)" default-first-option @input="testSX" @change="productChange($event,idx,index)" v-model="domain.productName" filterable remote placeholder="请选择产品名称" @focus="productFocus" clearable :filter-method="materialsMatch">
                  <el-option v-for="item in productOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="规格" :prop="'operationMaterials.'+index+'.productList.'+idx+'.specification'" :rules="rules.specification">
                <el-select default-first-option @input="testSX" v-model="domain.specification" placeholder="请选择产品规格" clearable filterable remote @change="domainChange($event,idx,index)">
                  <el-option v-for="(item,index) in domain.specOptions" :key="index" :label="item.menuSpec" :value="item.menuSpec"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量" class="list" :prop="'operationMaterials.'+index+'.productList.'+idx+'.number'" :rules="rules.number">
                <el-input @input="testSX" v-model="domain.number" placeholder="请输入数量"></el-input>
              </el-form-item>
              <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain,idx,index)" v-show="idx > 0">
                <i class="el-icon-delete"></i>
              </el-button>
            </div>
            <el-form-item style="text-align: right;margin-right:5%;">
              <el-button @click="editAddDomain(index)" type="primary" size="mini">新增产品</el-button>
            </el-form-item>
            <el-form-item class="button">
              <el-button size="mini" type="danger" @click.prevent="removeDomain(item,index)" v-show="index > 0">删除手术</el-button>
            </el-form-item>
          </div>
        </div>
        <!-- <el-form-item style="text-align: right;margin-right:5%;">
          <el-button @click="addDomain" type="primary" size="mini">新增手术</el-button>
        </el-form-item> -->
        <div class="footer">
          <el-form-item>
            <el-button type="danger" @click="resetForm('formData')">取 消</el-button>
            <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 选择信息弹框 -->
      <el-dialog center class="dialogItem" :visible.sync="dialogFormCheck" append-to-body>
        <!-- <el-radio-group class="cardName" size="medium" v-model="loadOption">
          <el-radio border v-for="(item,index) in loadOptions" :key="index" :label="item.clientCard" @click.native.prevent="clickitem(item.clientCard)">
            <div class="infoSource">
              <span><span class="nameSex">姓名:</span>{{item.clientName}}</span>
              <span><span class="nameSex">性别:</span>{{item.clientSex}}</span>
            </div>
            <div class="infoSource"><span class="nameSex">手机号:</span>{{item.clientMobile.replaceAll('，', ' ')}}</div>
            <div class="infoSource"><span class="nameSex">卡号:</span>{{item.clientCard}}</div>
            <div class="infoSource"><span class="nameSex">信息来源:</span>{{item.scName}}</div>
          </el-radio>
        </el-radio-group> -->
        <el-checkbox-group class="cardName" size="medium" v-model="loadOption">
          <el-checkbox-button style="display:block;" v-for="(item,index) in loadOptions" :key="index" :label="item.clientCard">
            <div class="infoSource">
              <span><span class="nameSex">姓名:</span>{{item.clientName}}</span>
              <span><span class="nameSex">性别:</span>{{item.clientSex}}</span>
            </div>
            <div class="infoSource"><span class="nameSex">手机号:</span>{{item.clientMobile.replaceAll('，', ' ')}}</div>
            <div class="infoSource"><span class="nameSex">卡号:</span>{{item.clientCard}}</div>
            <div class="infoSource"><span class="nameSex">信息来源:</span>{{item.scName}}</div>
          </el-checkbox-button>
        </el-checkbox-group>
        <div class="footer">
          <el-button type="primary" icon="el-icon-arrow-left" @click="lastPage">上一页</el-button>
          <el-button type="primary" @click="nextpage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
          <el-button type="danger" @click="dialogFormCheck = false">取 消</el-button>
          <el-button type="primary" @click="addInfo">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import pinyin from 'pinyin-match'
import loginVue from '../login.vue';
import Store from "../../assets/common.vue";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      else if (value.length < 8) {
        return callback(new Error('手机号需要大于八位数'));
      }
      else if (isNaN(value)) {
        return callback(new Error('手机号格式不正确'));
      }
      else {
        callback();
      }
    };
    return {
      loadOption: [],
      rules: {
        clientMobile: [
          { required: true, validator: checkPhone, trigger: 'blur', }
        ],
        clientCard: [
          { required: true, message: '请添加客户卡号', trigger: 'blur' },
        ],
        serviceName: [
          { required: true, message: '请添加客服姓名', trigger: 'blur' },
        ],
        clientName: [
          { required: true, message: '请添加客户姓名', trigger: 'blur' },
        ],
        clientSex: [
          { required: true, message: '请添加客户性别', trigger: 'blur' },
        ],
        time: [
          { required: true, message: '请添加日期', trigger: 'blur' },
        ],
        areaName: [
          { required: true, message: '请添加院区', trigger: 'blur' },
        ],
        operationName: [
          { required: true, message: '请添加手术名称', trigger: 'blur' },
        ],
        diagnosis: [
          { required: true, message: '请添加诊断', trigger: 'blur' },
        ],
        anesthesiaMode: [
          { required: true, message: '请添加麻醉方式', trigger: 'blur' },
        ],
        operatorDoctor: [
          { required: true, message: '请添加主刀医生', trigger: 'blur' },
        ],
        assistantDoctor: [
          { required: true, message: '请添加副刀医生', trigger: 'blur' },
        ],
        anesthetistName: [
          { required: true, message: '请添加医助姓名', trigger: 'blur' },
        ],
        tourNurse: [
          { required: true, message: '请添加巡回护士', trigger: 'blur' },
        ],
        surgeryName: [
          { required: true, message: '请添加手术名称', trigger: 'blur' },
        ],
        practicalOperationName: [
          { required: true, message: '请添加实际手术名称', trigger: 'blur' },
        ],
        doctorName: [
          { required: true, message: '请添加医生姓名', trigger: 'blur' },
        ],
        nurseName: [
          { required: true, message: '请添加护士姓名', trigger: 'blur' },
        ],
        assistantName: [
          { required: true, message: '请添加医助姓名', trigger: 'blur' },
        ],
        anesthetistName: [
          { required: true, message: '请添加麻醉医生', trigger: 'blur' },
        ],
        place: [
          { required: true, message: '请添加场地', trigger: 'blur' },
        ],
        entranceTime: [
          { required: true, message: '请添加入室时间', trigger: 'blur' },
        ],
        productName: [
          { required: true, message: '请添加产品名称', trigger: 'blur' },
        ],
        specification: [
          { required: true, message: '请添加产品规格', trigger: 'blur' },
        ],
        number: [
          { required: true, message: '请添加产品数量', trigger: 'blur' },
        ],
        category: [
          { required: true, message: '请添加类别', trigger: 'blur' },
        ],
        practicalOperationDoctor: [
          { required: true, message: '请添加实际手术医生', trigger: 'blur' },
        ],
      },
      sexey: [
        {
          label: '男',
          value: '0'
        }, {
          label: '女',
          value: '1'
        },
      ],
      areaOptions: [
        {
          id: '伯思立',
          menuName: '伯思立'
        }, {
          id: '百达丽',
          menuName: '百达丽'
        }, {
          id: '翡立思',
          menuName: '翡立思'
        }
      ],
      formData: {
        clientMobile: '',
        clientCard: '',
        clientName: '',
        serviceName: '',
        clientSex: "",
        clientAge: '',
        serviceName: '',
        category: "",
        time: '',
        areaName: '',
        dsepartmentName: '美容外科',
        operationRegister: [
          {
            operatorDoctor: '',
            anesthetistName: '',
            operationName: '',
            diagnosis: '',
            anesthesiaMode: '',
            assistantDoctor: '',
            practicalOperationDoctor: '',
            washNurse: '',
            tourNurse: '',
            remarks: '',
          }
        ],
        operationMaterials: [
          {
            operationName: "",
            practicalOperationName: '',
            doctorName: '',
            nurseName: "",
            assistantName: '',
            anesthetistName: '',
            place: '',
            entranceTime: '',
            operationTimeStart: '',
            operationTimeEnd: '',
            anesthesiaMode: '',
            anesthesiaTimeEnd: "",
            anesthesiaTimeStart: "",
            productList: [
              {
                productName: '',
                specification: '',
                number: '',
                money: ''
              }
            ],
          }
        ],
      },
      dialogForm: false,
      loading: false,
      disabled: true,
      doctorOptions: [],
      placeOptions: [],
      diagnosisOptions: [],
      operaOptions: [],
      infoOptions: [],
      anesOptions: [],
      productOptions: [],
      ageOptions: [],
      loadOptions: [],
      dialogFormCheck: false,
      options: [{
        value: '内',
        label: '内'
      }, {
        value: '外',
        label: '外'
      },],
      allData: {},
      list1: [],
      list2: [],
      list3: [],
      list6: [],
      list7: [],
      list4: [],
      list8: [],
      list10: [],
      list11: [],
      list12: [],
      list13: [],
      list14: [],
      newData: [],
      listData: [],
    }
  },
  created() {
    api.requestQuiet("/register/findSurgeryRegisterMenuList", {}, (res) => {
      if (res.result == true) {
        this.allData = res.data
        this.allData.forEach(ele => {
          if (ele.menuType == 1) {
            this.list1.push(ele)
          } else if (ele.menuType == 2) {
            this.list2.push(ele)
          } else if (ele.menuType == 3) {
            this.list3.push(ele)
          } else if (ele.menuType == 6) {
            this.list6.push(ele)
          } else if (ele.menuType == 8) {
            this.list8.push(ele)
          } else if (ele.menuType == 10) {
            this.list10.push(ele)
          } else if (ele.menuType == 11) {
            this.list11.push(ele)
          } else if (ele.menuType == 12) {
            this.list12.push(ele)
          } else if (ele.menuType == 13) {
            this.list13.push(ele)
          } else if (ele.menuType == 14) {
            this.list14.push(ele)
          } else if (ele.menuType == 4) {
            this.list4.push(ele)
          } else if (ele.menuType == 7) {
            this.list7.push(ele)
          }
        });
        this.list7 = [...this.list7, ...this.list4]
        this.loading = false
      } else {
        _g.toast("warning", res.errMsg);
      }
    }, (err) => {
      this.loading = true
    })
  },
  methods: {
    initAge() {
      for (let i = 1; i <= 100; i++) {
        this.ageOptions.push(i);
      }
    },
    // 编辑时新增部位
    editAddDomain(index) {
      this.formData.operationMaterials[index].productList.push({
        key: Date.now(),
        productName: "",
        specification: '',
        number: ''
      });
    },
    // 编辑时删除部位
    editRemoveDomain(item, listIndex, nextIndex) {
      var index = this.formData.operationMaterials[nextIndex].productList.indexOf(item)
      if (index !== -1) {
        this.formData.operationMaterials[nextIndex].productList.splice(listIndex, 1)
      }
    },
    // 删除手术
    removeDomain(item, listIndex) {
      var index = this.formData.operationMaterials.indexOf(item)
      if (index !== -1) {
        // 删除手术耗材表
        this.formData.operationMaterials.splice(listIndex, 1)
        // 同时删除手术登记表
        this.formData.operationRegister.splice(listIndex, 1)
      }
      // 同时删除手术登记表
      // this.removeForm()
    },
    // 添加手术登记表
    removeForm(item, listIndex) {
      console.log(listIndex);
      var index = this.formData.operationRegister.indexOf(item)
      if (index !== -1) {
        // 删除手术登记表
        this.formData.operationRegister.splice(listIndex, 1)
        // 同时删除手术耗材表
        this.formData.operationMaterials.splice(listIndex, 1)
      }

    },
    addForm() {
      // 新增手术登记表
      this.formData.operationRegister.push({
        operationName: '',
        diagnosis: '',
        anesthesiaMode: '',
        operatorDoctor: "",
        assistantDoctor: '',
        anesthetistName: "",
        washNurse: "",
        tourNurse: '',
        remarks: '',
        key: Date.now()
      });
      // 新增手术耗材表
      this.formData.operationMaterials.push({
        operationName: '',
        productList: [
          {
            productName: '',
            specification: '',
            number: '',
            money: ''
          }
        ],
        key: Date.now()
      });
    },
    openDialog1Visible() {
      this.dialogForm = true;
    },
    openLoading() {
      // console.log(this.allData);
      if (this.allData && this.allData.length != 0) {
        this.loading = false
      } else {
        this.loading = true
      }
    },
    // 取消
    resetForm(formData) {
      this.$refs[formData].resetFields();
      this.dialogForm = false
      this.formData = {
        clientMobile: '',
        clientCard: '',
        clientName: '',
        serviceName: '',
        clientSex: "",
        clientAge: '',
        serviceName: '',
        category: "",
        time: '',
        areaName: '',
        dsepartmentName: '美容外科',
        operationRegister: [
          {
            operatorDoctor: '',
            anesthetistName: '',
            operationName: '',
            diagnosis: '',
            anesthesiaMode: '',
            assistantDoctor: '',
            practicalOperationDoctor: '',
            washNurse: '',
            tourNurse: '',
            remarks: '',
          }
        ],
        operationMaterials: [
          {
            operationName: "",
            practicalOperationName: '',
            doctorName: '',
            nurseName: "",
            assistantName: '',
            anesthetistName: '',
            place: '',
            entranceTime: '',
            operationTimeStart: '',
            operationTimeEnd: '',
            anesthesiaMode: '',
            anesthesiaTimeEnd: "",
            anesthesiaTimeStart: "",
            productList: [
              {
                productName: '',
                specification: '',
                number: '',
                money: ''
              }
            ],
          }
        ],
      }
    },
    // 确认提交信息
    doAddgoods(formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.formData.operationMaterials.forEach(ele => {
            if (ele.assistantName) {
              ele.assistantName = ele.assistantName.toString()
            }
            if (ele.nurseName) {
              ele.nurseName = ele.nurseName.toString()
            }
            if (ele.anesthetistName) {
              ele.anesthetistName = ele.anesthetistName.toString()
            }
            if (ele.doctorName) {
              ele.doctorName = ele.doctorName.toString()
            }
            if (ele.operationName) {
              ele.operationName = ele.operationName.toString()
            }
            if (ele.practicalOperationName) {
              ele.practicalOperationName = ele.practicalOperationName.toString()
            }
          });
          this.formData.operationRegister.forEach(ele => {
            if (ele.operationName) {
              ele.operationName = ele.operationName.toString()
            }
            if (ele.diagnosis) {
              ele.diagnosis = ele.diagnosis.toString()
            }
            if (ele.anesthesiaMode) {
              ele.anesthesiaMode = ele.anesthesiaMode.toString()
            }
            if (ele.assistantDoctor) {
              ele.assistantDoctor = ele.assistantDoctor.toString()
            }
            if (ele.washNurse) {
              ele.washNurse = ele.washNurse.toString()
            }
            if (ele.tourNurse) {
              ele.tourNurse = ele.tourNurse.toString()
            }
            if (ele.practicalOperationDoctor) {
              ele.practicalOperationDoctor = ele.practicalOperationDoctor.toString()
            }
          });
          this.formData.userName = Lockr.get("userName")
          this.formData.createBy = Lockr.get("empId")
          console.log(Lockr.get("empId"));
          if (Lockr.get("empId") == '' || !Lockr.get("empId")) {
            _g.toast("error", 'userId已失效,请退出重新登录账号!');
            return;
          }
          this.formData.clientMobile = this.formData.clientMobile.replaceAll('，', ' ')
          console.log(this.formData)
          var that = this
          api.requestQuiet("/register/createSurgeryRegister", this.formData, (res) => {
            console.log(res)
            if (res.result == true) {
              this.dialogForm = false;
              if (res.data != '') {
                _g.toast("success", '外科登记表添加成功!');
                this.$emit('add-comment')
                this.$refs[formData].resetFields();
                // this.formData.clientMobile = ''
                // this.formData.clientCard = ''
                // this.formData.clientName = ''
                this.formData = {
                  clientMobile: '',
                  clientCard: '',
                  clientName: '',
                  serviceName: '',
                  clientSex: "",
                  clientAge: '',
                  serviceName: '',
                  category: "",
                  time: '',
                  areaName: '',
                  dsepartmentName: '美容外科',
                  operationRegister: [
                    {
                      operatorDoctor: '',
                      anesthetistName: '',
                      operationName: '',
                      diagnosis: '',
                      anesthesiaMode: '',
                      assistantDoctor: '',
                      practicalOperationDoctor: '',
                      washNurse: '',
                      tourNurse: '',
                      remarks: '',
                    }
                  ],
                  operationMaterials: [
                    {
                      operationName: "",
                      practicalOperationName: '',
                      doctorName: '',
                      nurseName: "",
                      assistantName: '',
                      anesthetistName: '',
                      place: '',
                      entranceTime: '',
                      operationTimeStart: '',
                      operationTimeEnd: '',
                      anesthesiaMode: '',
                      anesthesiaTimeEnd: "",
                      anesthesiaTimeStart: "",
                      productList: [
                        {
                          productName: '',
                          specification: '',
                          number: '',
                          money: ''
                        }
                      ],
                    }
                  ],
                }
              }
            } else {
              _g.toast("error", res.errMsg);
            }
          }, (err) => {
            that.formData.operationMaterials.forEach(ele => {
              if (ele.assistantName) {
                ele.assistantName = ele.assistantName.split(',')
              }
              if (ele.nurseName) {
                ele.nurseName = ele.nurseName.split(',')
              }
              if (ele.anesthetistName) {
                ele.anesthetistName = ele.anesthetistName.split(',')
              }
              if (ele.doctorName) {
                ele.doctorName = ele.doctorName.split(',')
              }
              if (ele.practicalOperationName) {
                ele.practicalOperationName = ele.practicalOperationName.split(',')
              }
            });
            that.formData.operationRegister.forEach(ele => {
              if (ele.practicalOperationDoctor) {
                ele.practicalOperationDoctor = ele.practicalOperationDoctor.split(',')
              }
              if (ele.operationName) {
                ele.operationName = ele.operationName.split(',')
              }
              if (ele.diagnosis) {
                ele.diagnosis = ele.diagnosis.split(',')
              }
              if (ele.anesthesiaMode) {
                ele.anesthesiaMode = ele.anesthesiaMode.split(',')
              }
              if (ele.assistantDoctor) {
                ele.assistantDoctor = ele.assistantDoctor.split(',')
              }
              if (ele.washNurse) {
                ele.washNurse = ele.washNurse.split(',')
              }
              if (ele.tourNurse) {
                ele.tourNurse = ele.tourNurse.split(',')
              }
            });
          });
        } else {
          _g.toast("warning", '请完善信息');
          return false;
        }
      });
    },
    testSX() {
      this.$forceUpdate()
    },
    nextpage() {
      let data = {
        clientMobile: this.formData.clientMobile,
        clientCard: this.formData.clientCard,
        clientName: this.formData.clientName,
        pageIndex: Lockr.get("selected") + 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          //当前页数+1
          this.loadOptions = res.data.mapList
          Lockr.set("selected", res.data.pageIndex)
        } else {
          _g.toast("warning", '已经是最后一页啦!');
          Lockr.set("selected", res.data.pageIndex)
        }
      }, (err) => {
        this.loading = false
      });
    },
    lastPage() {
      if (Lockr.get("selected") < 2) {
        _g.toast("warning", '已经是第一页啦!');
      } else {
        let data = {
          clientMobile: this.formData.clientMobile,
          clientCard: this.formData.clientCard,
          clientName: this.formData.clientName,
          pageIndex: Lockr.get("selected") - 1,
        }
        api.requestQuiet("/register/getClientInformation", data, (res) => {
          console.log(res)
          if (res.result == true) {
            this.loadOptions = res.data.mapList
            Lockr.set("selected", res.data.pageIndex)
          }
        }, (err) => {
          this.loading = false
        });
      }
    },
    // 获取信息
    getInfo() {
      this.formData.clientAge = ""
      this.formData.clientSex = ''
      this.formData.serviceName = ''
      this.loadOption = []
      Lockr.set("selected", 1)
      // if ((this.formData.clientMobile == undefined || this.formData.clientMobile == "") && (this.formData.clientName == undefined || this.formData.clientName == "") && (this.formData.clientCard == undefined || this.formData.clientCard == "")) {
      //   _g.toast("error", '请添加手机号或卡号或姓名');
      //   return;
      // }
      this.loading = true
      let data = {
        clientMobile: this.formData.clientMobile,
        clientCard: this.formData.clientCard,
        clientName: this.formData.clientName,
        pageIndex: 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          this.loading = false
          if (res.data.length == 1) {
            this.formData.clientMobile = res.data[0].mapList.clientMobile
            this.formData.clientAge = res.data.mapList[0].clientAge
            this.formData.clientCard = res.data.mapList[0].clientCard
            this.formData.clientSex = res.data.mapList[0].clientSex
            this.formData.clientName = res.data.mapList[0].clientName
            this.formData.serviceName = res.data.mapList[0].serviceName
          } else {
            this.dialogFormCheck = true
            this.loadOptions = res.data.mapList
          }
        } else {
          this.loading = false
          //   获取信息之后是否可以编辑信息
          this.disabled = false
          // 接口未查询到
          this.formData.information = 1//0是1否   是否宏脉数据
          _g.toast("warning", '请手动添加客户信息');
        }
      }, (err) => {
        this.loading = false
      });
    },
    docotrBlur() {
      console.log('医生失去焦点');
    },
    docotrFocus(menuType) {
      if (menuType == 10) {
        this.doctorOptions = this.list10
      } else if (menuType == 11) {
        this.doctorOptions = this.list11
      } else if (menuType == 12) {
        this.doctorOptions = this.list12
      } else if (menuType == 13) {
        this.doctorOptions = this.list13
      } else if (menuType == 14) {
        this.doctorOptions = this.list14
      }
      console.log(this.doctorOptions);
      // let data = {
      //   menuType: menuType
      // }
      // api.request('/register/findRegisterMenuList', data, (res) => {
      //   // console.log(res)
      //   this.doctorOptions = res.data
      // })
    },

    docotrMatch(val, menuType) {
      // this.copyOrderDetails = Object.assign(this.doctorOptions)
      if (menuType == 10) {
        this.copyOrderDetails = Object.assign(this.list10)
      } else if (menuType == 11) {
        this.copyOrderDetails = Object.assign(this.list11)
      } else if (menuType == 12) {
        this.copyOrderDetails = Object.assign(this.list12)
      } else if (menuType == 13) {
        this.copyOrderDetails = Object.assign(this.list13)
      } else if (menuType == 14) {
        this.copyOrderDetails = Object.assign(this.list14)
      }
      if (val) {
        console.log(val);
        this.doctorOptions = this.copyOrderDetails.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.doctorOptions = this.copyOrderDetails
      }
    },
    // 场地选择
    placeFocus() {
      this.placeOptions = this.list1
    },
    placeMatch(val) {
      this.copyplaceOptions = Object.assign(this.list1)
      if (val) {
        this.placeOptions = this.copyplaceOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.placeOptions = this.copyplaceOptions
      }
      // })
    },
    // 诊断选择
    diagnosisFocus(e, index) {
      this.diagnosisOptions = []
      if (this.formData.operationRegister[index].operationName.length == 0) {
        this.diagnosisOptions = this.list3
        this.newData = this.diagnosisOptions
      } else if (this.formData.operationRegister[index].operationName.length != 0) {
        // 筛选当前选择的手术名称所对应的诊断
        let date = this.list6.filter(item => this.formData.operationRegister[index].operationName.indexOf(item.menuName) > -1)
        let isClude = date.map((value) => value.menuName).indexOf('其他') > -1 || date.map((value) => value.menuName).indexOf('无') > -1
        if (isClude == true) {
          this.diagnosisOptions = this.list3
          this.newData = this.diagnosisOptions
        } else if (isClude == false) {
          let array = []
          date.forEach(ele => {
            ele.registerMenuDtoList.forEach(item => {
              array.push(item)
            });
          });
          // 数组去重 一个诊断对应多个手术名称
          if (array.length != 0) {
            let obj = {};
            let peon = array.reduce((cur, next) => {
              obj[next.menuName] ? "" : obj[next.menuName] = true && cur.push(next);
              return cur;
            }, []) //设置cur默认类型为数组，并且初始值为空的数组
            if (peon.length == 0) {
              this.diagnosisOptions = this.list3
              this.newData = this.diagnosisOptions
            } else if (peon.length != 0) {
              this.diagnosisOptions = peon
              this.diagnosisOptions.unshift({ menuName: '无', id: 999999 }, { menuName: '其他', id: 111111 })
              this.newData = this.diagnosisOptions
            }
          } else {
            this.diagnosisOptions = this.list3
          }
        }

      }
    },
    diagnosischange(val) {
      if (val == false) {
        this.diagnosisOptions = []
      }
    },
    diaChange(val) {
      // console.log(val);
    },
    diagnosMatch(val) {
      this.copydiagnosisOptions = Object.assign(this.newData)
      if (val) {
        this.diagnosisOptions = this.copydiagnosisOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.diagnosisOptions = this.copydiagnosisOptions
      }
      // })
    },
    arrHasOtherArr(arr, arr1) {
      return arr1.every(item => arr.includes(item))
    },
    // 登记表手术名称
    operaFocus(e, index) {
      this.operaOptions = []
      let serviceRes = this.list3.map((value) => value.menuName)
      let isTrue = this.arrHasOtherArr(serviceRes, this.formData.operationRegister[index].diagnosis)
      if (this.formData.operationRegister[index].diagnosis.length == 0 || isTrue == false) {
        this.operaOptions = this.list6
        this.listData = this.operaOptions
      } else if (this.formData.operationRegister[index].diagnosis.length != 0 || isTrue == true) {
        let date = this.list3.filter(item => this.formData.operationRegister[index].diagnosis.indexOf(item.menuName) > -1)
        let isClude = date.map((value) => value.menuName).indexOf('其他') > -1 || date.map((value) => value.menuName).indexOf('无') > -1
        if (isClude == true) {
          this.operaOptions = this.list6
          this.listData = this.operaOptions
        } else if (isClude == false) {
          let array = []
          date.forEach(ele => {
            ele.registerMenuDtoList.forEach(item => {
              array.push(item)
            });
          });
          // 数组去重 一个诊断对应多个手术名称
          let obj = {};
          let peon = array.reduce((cur, next) => {
            obj[next.menuName] ? "" : obj[next.menuName] = true && cur.push(next);
            return cur;
          }, []) //设置cur默认类型为数组，并且初始值为空的数组
          if (peon.length == 0) {
            this.operaOptions = this.list6
            this.listData = this.operaOptions
          } else if (peon.length != 0) {
            this.operaOptions = peon
            this.operaOptions.unshift({ menuName: '无', id: 999999 }, { menuName: '其他', id: 111111 })
            this.listData = this.operaOptions
          }
        }
      }
    },
    operaChange(val) {
      if (val == false) {
        this.operaOptions = []
      }
    },
    operationNameMatch(val) {
      this.copyoperaOptions = Object.assign(this.listData)
      if (val) {
        this.operaOptions = this.copyoperaOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.operaOptions = this.copyoperaOptions
      }
      // })
    },
    // 麻醉方式
    anesFocus() {
      this.anesOptions = this.list2
      // let data = {}
      // api.request('/register/findRegisterMenuAnesthetistList', data, (res) => {
      //   // console.log(res)
      //   this.anesOptions = res.data
      // })
    },
    // 选择产品名称
    productFocus() {
      // let data = {}
      // api.request('/register/findRegisterMenuOperationList', data, (res) => {
      //   // console.log(res)
      //   this.productOptions = res.data
      // })
      this.productOptions = this.list7
    },
    productChange(val, idx, index) {
      this.productOptions.forEach(ele => {
        if (ele.menuName == val) {
          if (val == '无') {
            this.formData.operationMaterials[index].productList[idx].specification = '无'
            this.formData.operationMaterials[index].productList[idx].number = '0'
          } else if (val != '无') {
            this.formData.operationMaterials[index].productList[idx].specOptions = ele.registerMenuDtoList
            this.formData.operationMaterials[index].productList[idx].specification = ''
            this.formData.operationMaterials[index].productList[idx].number = '1'
            this.formData.operationMaterials[index].productList[idx].price = ele.price
          }
        }
      });
    },
    domainChange(val, idx, index) {
      this.formData.operationMaterials[index].productList[idx].specOptions.forEach(ele => {
        if (val == ele.menuSpec) {
          this.formData.operationMaterials[index].productList[idx].price = ele.price
        }
      });
    },
    materialsMatch(val) {
      //   api.request('/register/findRegisterMenuOperationList', {}, (res) => {
      //     this.productOptions = res.data
      //     this.copyproductOptions = Object.assign(this.productOptions)
      this.copyproductOptions = Object.assign(this.list7)
      if (val) {
        this.productOptions = this.copyproductOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.productOptions = this.copyproductOptions
      }
      // })
    },
    // 确定选择信息
    addInfo() {
      if (this.loadOption && this.loadOption != '') {
        // 提取数组中相同的元素
        let mobileArr = this.loadOptions.filter(item => this.loadOption.some(ele => ele === item.clientCard));
        // 多个电话号码数据处理 /拼接赋值.join('').replaceAll(' ', '/')
        console.log(mobileArr);
        let arr = (mobileArr.map((value) => value.clientMobile)).map(function (item) {
          return item.replaceAll(' ', '/')
        })
        // console.log(arr)
        // console.log(mobileArr.map((value) => value.clientMobile))
        let mobileRes = arr.join('/')
        // console.log(mobileRes)
        this.formData.clientMobile = mobileRes
        // 姓名处理
        let nameRes = mobileArr.map((value) => value.clientName).filter((num, index) => { return num !== '' }).join('/')
        this.formData.clientName = nameRes
        // 年龄处理
        // let ageRes = mobileArr.map((value) => value.clientAge).filter((num, index) => { return num !== '' }).join('/')
        // this.formData.clientAge = ageRes
        // 卡号处理
        let cardRes = mobileArr.map((value) => value.clientCard).filter((num, index) => { return num !== '' }).join('/')
        this.formData.clientCard = cardRes
        // 性别处理
        let sexRes = mobileArr.map((value) => value.clientSex).filter((num, index) => { return num !== '' }).join('/')
        this.formData.clientSex = sexRes
        // 客服处理
        let serviceRes = mobileArr.map((value) => value.serviceName).filter((num, index) => { return num !== '' }).join('/')
        // if (serviceRes != '/') {
        this.formData.serviceName = serviceRes
        // }
        // 渠道
        let channelRes = mobileArr.map((value) => value.scName).filter((num, index) => { return num !== '' }).join('/')
        this.formData.channel = channelRes
        //// this.formData.information = 0//0是1否   是否宏脉数据
        this.dialogFormCheck = false
      }
    },
    operationChange(event, index) {
      // console.log(event)
      // console.log(index)
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].operationName = event
        this.formData.operationMaterials[index].practicalOperationName = event
      }
    },
    // 洗手护士
    nurseChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].nurseName = event
      }
    },
    // 医助
    assistChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].assistantName = event
      }
    },
    // 麻醉医生
    anestChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].anesthetistName = event.split(' ')
      }
    },
    // 麻醉方式
    modeChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].anesthesiaMode = event
      }
    },
    //实际手术医生
    practicalChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].doctorName = event
      }
    },
    // 主刀医生
    regisChange(event, index) {
      if (this.formData.operationRegister[index] != undefined) {
        // 主刀医生带入实际手术医生
        this.formData.operationRegister[index].practicalOperationDoctor = event.split(' ')
        // 并且带入医生姓名
        this.formData.operationMaterials[index].doctorName = event.split(' ')
      }
    },
    // 判断时间
    timeChange(val, index) {
      if (this.formData.operationMaterials[index].operationTimeStart) {
        let t1 = (this.formData.operationMaterials[index].operationTimeStart)
        let t2 = (this.formData.operationMaterials[index].operationTimeEnd)
        if (t1 > t2) {
          _g.toast("error", '手术结束时间不能小于开始时间!');
        }
      } else {
        _g.toast("error", '请先填写手术开始时间!');
      }
    },
    valueChange(val, index) {
      if (this.formData.operationMaterials[index].anesthesiaTimeStart) {
        let t1 = (this.formData.operationMaterials[index].anesthesiaTimeStart)
        let t2 = (this.formData.operationMaterials[index].anesthesiaTimeEnd)
        if (t1 > t2) {
          _g.toast("error", '麻醉结束时间不能小于开始时间!');
        }
      } else {
        _g.toast("error", '请先填写麻醉开始时间!');
      }
    },
    // 监听回车事件
    enterDoctor(e, index, val, idx) {
      // console.log(this.formData.operationRegister[index].assistantDoctor[this.formData.operationRegister[index].assistantDoctor.length - 1]);
      if (val == 13) {//刀医生
        if (this.doctorOptions[0] != undefined) {
          this.formData.operationRegister[index].operatorDoctor = this.doctorOptions[0].menuName
          this.$refs.doctor13[0].blur()
        }
      } else if (val == 11) {//麻醉医生
        if (this.doctorOptions[0] != undefined) {
          this.formData.operationRegister[index].anesthetistName = this.doctorOptions[0].menuName
          this.$refs.doctor11[0].blur()
        }

      } else if (val == 26) {//场地
        if (this.placeOptions[0] != undefined) {
          this.formData.operationMaterials[index].place = this.placeOptions[0].menuName
          this.$refs.place[0].blur()
        }

      } else if (val == 30) {//产品名称
        if (this.productOptions[0] != undefined) {
          console.log(this.productOptions[0].menuName);
          this.formData.operationMaterials[index].productList[idx].productName = this.productOptions[0].menuName
          this.$refs.productName[idx].blur()
          this.productChange(this.formData.operationMaterials[index].productList[idx].productName, idx, index)
        }
      } else if (val == 14) {//副刀医生
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationRegister[index].assistantDoctor.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 16) {//实际手术医生
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationRegister[index].practicalOperationDoctor.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 17) {//洗手护士
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationRegister[index].washNurse.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 18) {//巡回护士
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationRegister[index].tourNurse.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 19) {//医生姓名
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].doctorName.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 20) {//护士姓名
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].nurseName.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 21) {//医助姓名
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].assistantName.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 22) {//麻醉医生
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].anesthetistName.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 23) {//规范手术名称
        if (this.operaOptions.length != 0 && this.operaOptions[0].menuName != '无') {
          this.formData.operationRegister[index].operationName.push(this.operaOptions[0].menuName)
        }
      } else if (val == 24) {//诊断
        if (this.diagnosisOptions[0].menuName != '无') {
          this.formData.operationRegister[index].diagnosis.push(this.diagnosisOptions[0].menuName)
        }
        this.diagnosisFocus(e, index)
      } else if (val == 25) {//实际手术名称
        if (this.infoOptions.length != 0 && this.infoOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].practicalOperationName.push(this.infoOptions[0].menuName)
        }
      } else if (val == 28) {//手术名称
        if (this.operaOptions.length != 0 && this.operaOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].operationName.push(this.operaOptions[0].menuName)
        }
      }

    },


  }
}
</script>
<style scoped>
.dialogItem >>> .el-input__inner {
  width: 200px;
  height: 38px;
}
.dialogItem >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
  height: 38px;
}
.cardName {
  margin-bottom: 50px;
}
.dialogItem >>> .el-radio--medium.is-bordered {
  width: 500px !important;
  height: 115px !important;
  /* line-height: 20px; */
  margin-bottom: 20px !important;
}
.dialogItem >>> .el-checkbox-button--medium .el-checkbox-button__inner {
  text-align: left;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
}
.dialogItem >>> .el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
}
.dialogItem >>> .el-radio--medium.is-bordered .el-radio__label {
  font-size: 16px !important;
}
.dialogItem >>> .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}
.list >>> .el-input__inner {
  width: 150px;
  height: 38px;
}
.timeStyle >>> .el-input__inner {
  width: 500px;
  height: 38px;
}
.dialogItem >>> .el-form-item {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.addInjectable >>> .el-dialog {
  width: 1050px !important;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
}
.flex {
  display: flex;
  align-items: center;
  background: #c3cedf;
  border-radius: 10px;
  margin-bottom: 5px;
}
.addInjectable >>> .el-form-item__content {
  line-height: 35px !important;
}
.addInjectable >>> .el-button i {
  margin: 0 !important;
}
.info {
  margin-top: 18px;
}
.service >>> .el-input__inner {
  width: 140px;
  height: 38px;
}
.footer {
  display: flex;
  justify-content: center;
}
.dialogItem >>> .el-radio__input {
  display: none;
}
.dialogItem >>> .el-radio__label {
  padding-left: 0 !important;
}
.infoSource {
  margin-bottom: 10px;
}
.dialogItem >>> .el-input--suffix .el-input__inner {
  padding-right: 5px;
}
.buttonStyle {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.nameSex {
  font-weight: bold;
  margin-bottom: 10px;
  margin-left: 16px;
}
.no >>> .el-select-dropdown {
  display: none;
}
</style>